import { GameplayTier } from '__generated__/globalTypes';

const GAMEPLAY_TIER_ORDER = [
  GameplayTier.GOAT,
  GameplayTier.STAR,
  GameplayTier.IMPACT,
  GameplayTier.ROSTER,
  GameplayTier.DNP,
];

export const isGameplayTier = (value: string): value is GameplayTier => {
  return GAMEPLAY_TIER_ORDER.includes(value as GameplayTier);
};

const sortByGameplayTier = (a: string, b: string) => {
  if (!isGameplayTier(a)) {
    return 1;
  }
  if (!isGameplayTier(b)) {
    return -1;
  }
  return GAMEPLAY_TIER_ORDER.indexOf(a) - GAMEPLAY_TIER_ORDER.indexOf(b);
};

export { sortByGameplayTier };
